import { getBrandName } from '../../../../Utils/helper';
import { CertName } from './styled';

export default function index(props) {
  const { productId, certName, desktop } = props;

  const getProductCategory = () => {
    return getBrandName(productId);
  };

  return (
    <>
      {getProductCategory() ? (
        <CertName desktop={desktop}>
          {certName || getProductCategory()}
        </CertName>
      ) : null}
    </>
  );
}
